import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {LocationType} from "../../../commons/types/location.type";
import {FulfillmentDialogService} from "../../services/fulfillment-dialogs-service.service";
import {getFulfillmentLineItems} from "../../utils/fulfillment-line-items.util";

export class FulfillmentTableStepItemComponent implements IController {

  fulfillment: any;
  columns: any;
  dynamicColumns: any;
  isCollapse: boolean;
  isSelected: string;
  excludeMode: boolean;
  onOpen: Function;
  onDispatch: Function;
  onSplit: Function;
  onAutoAssign: Function;
  onAssignAgent: Function;
  onCancelService: Function;
  onCancelAttempt: Function;
  onAssignRoute: Function;
  onAssignResourceAllocation: Function;
  onAddNote: Function;
  onCreateRoute: Function;
  onCompleteManually: Function;
  onToggleSelect: Function;
  onReset: Function;


  public selectedKeys: any;
  public steps: any;
  public stepsPackages: any = {}
  public locationTypes: typeof LocationType = LocationType;
  public canCopyVehicle: boolean;
  public canCopyAgent: boolean;
  public canCopyProgramName: boolean;
  public canCopyPickupDepot: boolean;
  public canCopyDestinationDepot: boolean;
  public canCopyPickupAccount: boolean;
  public canCopyDestinationAccount: boolean;
  public canCopyPickupCustomer: boolean;
  public canCopyDestinationCustomer: boolean;
  public canCopyPickupCustomContact: boolean;
  public canCopyDestinationCustomContact: boolean;
  public fulfillmentLinesItems: any = {};
  public fulfillmentLineItemsIds: string[] = [];
  public fulfillmentLineItemsTypes: string[] = [];
  public fulfillmentLineItemsBarcodes: string[] = [];
  public fulfillmentLineItemsDescription: string [] = [];
  public sitePackageItemsMap: any;


  constructor(private splitService, private fulfillmentDialogService: FulfillmentDialogService) {
  }

  $onInit() {
    this.sitePackageItemsMap = this.splitService.getSitePackageItemsMap();
    this._setStepsPackages();
    this._setFulfillmentLinesPackages();
    this.steps = this.fulfillment.fulfillmentSteps.filter(step => {
      return step.matchFilter;
    })

    let stepIndex = 1;
    this.steps.forEach(st => {
      st.stepNumber = stepIndex++;
    })
  }

  onViewPods(fulfillmentSteps, event) {
    this.fulfillmentDialogService.identificationsImages(fulfillmentSteps, 'Manage Leg PODs');
  }

  private _setStepsPackages() {
    _.forEach(this.fulfillment.fulfillmentSteps, step => {
      this.stepsPackages[step.id] = _.filter(this.fulfillment.items, fulfillmentItem => {
        if (_.includes(_.map(step.items, 'id'), fulfillmentItem.id)) {
          const item = _.find(step.items, i => {
            return i.id === fulfillmentItem.id
          });
          let fulfillmentItemCopy = fulfillmentItem;
          fulfillmentItemCopy.count = item.count;
          return fulfillmentItemCopy;
        }
      })
    })
  }

  private _setFulfillmentLinesPackages() {
    _.forEach(this.fulfillment.linesInfo, fulfillmentLine => {
      this.fulfillmentLinesItems[fulfillmentLine.id] = getFulfillmentLineItems(fulfillmentLine, _.get(this.fulfillment, 'items', []))
    })
    _.forOwn(this.fulfillmentLinesItems, (item, key) => {
      this.fulfillmentLineItemsIds[key] = _.map(item, 'id')
      this.fulfillmentLineItemsBarcodes[key] = _.chain(item)
        .filter(item => {
          return item.barcode
        })
        .map(item => {
          return item.barcode
        })
        .value();
      this.fulfillmentLineItemsTypes[key] = _.map(item, item => {
        return this.sitePackageItemsMap[item?.type]?.name;
      })
      this.fulfillmentLineItemsDescription[key] = _.chain(item)
        .filter(item => {
          return item.description
        })
        .map(item => {
          return item.description
        })
        .value();
    })
  }
}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentTableStepItem', {
    require: {
      fulfillmentStepsTableCtrl: '^fulfillmentStepsTable'
    },
    bindings: {
      fulfillment: '<',
      columns: '<',
      dynamicColumns: '<',
      isCollapse: '<',
      excludeMode: '<',
      onToggleSelect: '&',
      onOpen: '&',
      onDispatch: '&',
      onSplit: '&',
      onAutoAssign: '&',
      onAssignAgent: '&',
      onCancelService: '&',
      onCancelAttempt: '&',
      onAssignRoute: '&',
      onAssignResourceAllocation: '&',
      onAddNote: '&',
      onReset: '&',
      onCreateRoute: '&',
      onCompleteManually: '&'
    },
    template: require('./fulfillment-table-step-item.html').default,
    controller: FulfillmentTableStepItemComponent
  });
